import axios from 'axios'
import { getCookie } from 'shared/libs/storage/cookie'

import { StorageKeys } from '../cookie'

const token = getCookie(StorageKeys.access)

export const axiosInstance = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
})
